import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon/SvgIcon";

const defaultColor = "#306297";

const Exclusion = props => (
  <SvgIcon width="20px" height="20px" viewBox="0 0 25 25" {...props}>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Client-Account-Catalog"
        transform="translate(-254.000000, -166.000000)">
        <g id="Group-4" transform="translate(254.000000, 166.000000)">
          <circle
            id="Oval"
            fill={props.color || defaultColor}
            cx="10.5"
            cy="10.5"
            r="10.5"
          />
          <g
            id="Group-2"
            transform="translate(6.000000, 6.000000)"
            stroke="#FFFFFF"
            strokeLinecap="round"
            strokeWidth="2">
            <path d="M0.288770053,0.5 L8.75935829,9" id="Line-8" />
            <path d="M8.47058824,0.5 L0.288770053,9" id="Line-8" />
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export default Exclusion;
